<template>
  <div class="vc-wrap">
    <div class="vc-inner">

      <!-- 标题 -->
      <h1 class="vc-title">获取 SUNO 手机验证码</h1>

      <!-- URL 输入框 -->
      <input
          v-model.trim="url"
          type="text"
          class="vc-input"
          :placeholder="placeholder"
          @keyup.enter="getCode"
      />

      <!-- 按钮 -->
      <button
          class="vc-btn"
          :disabled="loading"
          @click="getCode"
      >
        {{ loading ? '发送中...' : '获取验证码' }}
      </button>

      <!-- 错误信息 -->
      <p v-if="error" class="vc-err">{{ error }}</p>

      <!-- 成功结果展示 -->
      <div v-if="code" class="vc-result">
        <div class="vc-result-title">验证码：</div>
        <div class="vc-result-code">{{ code }}</div>
      </div>

    </div>
  </div>
</template>

<script>
import { rechargeApi } from '@/utils/api'

export default {
  name: 'SimpleGetCode',
  props: {
    placeholder: { type: String, default: '请输入有效地址（http/https）' }
  },
  data () {
    return {
      websiteId: '10002',
      url: '',
      code: '',
      error: '',
      loading: false
    }
  },
  methods: {
    async reset() {
      this.url = ''
      this.code = ''
      this.error = ''
    },

    async getCode() {
      this.error = ''
      this.code = ''

      const normalized = this.normalizeUrl(this.url)
      if (!this.isValidUrl(normalized)) {
        this.error = '请输入正确的 URL 地址（需 http/https）'
        return
      }
      this.url = normalized

      try {
        this.loading = true
        const res = await rechargeApi.sunoVerifyCode({
          url: this.url,
          websiteId: '10002'
        })

        this.code = this.pickVerifyCode(res) || '无返回验证码'
      } catch (err) {
        this.error = err?.message || '发送失败，请稍后再试'
      } finally {
        this.loading = false
      }
    },

    normalizeUrl(v) {
      if (!v) return ''
      const hasScheme = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(v)
      return hasScheme ? v : `https://${v}`
    },

    isValidUrl(v) {
      try {
        const u = new URL(v)
        return u.protocol === 'http:' || u.protocol === 'https:'
      } catch {
        return false
      }
    },

    // —— 兼容提取：优先 data.code，其次 data(为字符串)，否则无 ——
    pickVerifyCode(res) {
      const data = res && res.data && res.data.data

      // 1) data 为对象，且存在 data.code（非空）
      if (data && typeof data === 'object' && !Array.isArray(data)) {
        const c = data.code
        if (c !== undefined && c !== null) {
          const s = String(c).trim()
          if (s) return s
        }
        return ''
      }

      // 2) data 为字符串：直接显示（非空）
      if (typeof data === 'string') {
        const s = data.trim()
        if (s) return s
        return ''
      }

      // 其他类型：无
      return ''
    },
  }
}
</script>

<style scoped>
.vc-wrap {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6f8;
}
.vc-inner {
  width: 760px;
  max-width: 92vw;
  text-align: center;
}

/* 标题样式 */
.vc-title {
  margin: 10px 0 18px;
  font-size: 18px;
  font-weight: 600;
  color: #111;
}

/* 输入框 */
.vc-input {
  width: 100%;
  height: 64px;
  font-size: 15px;
  padding: 0 20px;
  border: 2px solid #1e88ff;
  border-radius: 4px;
  outline: none;
  background: #fff;
  box-sizing: border-box;
}

/* 按钮 */
.vc-btn {
  margin: 40px auto 0;
  min-width: 220px;
  height: 54px;
  font-size: 18px;
  color: #111;
  background: #fff;
  border: 1px solid #333;
  border-radius: 8px;
  cursor: pointer;
}
.vc-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 错误提示 */
.vc-err {
  margin-top: 18px;
  color: #e53935;
  font-size: 14px;
}

/* 结果展示 */
.vc-result {
  margin-top: 40px;
  font-size: 16px;
  color: #111;
}

.vc-result-title {
  font-weight: 600;
  margin-bottom: 10px;
}

.vc-result-code {
  font-size: 20px;
  font-weight: 400;
  color: #1e88ff;
  word-wrap: break-word;
}
</style>
